export default __webpack_public_path__ + "static/media/utilidadesIcon.29d2f26b.svg";